import { useEffect, RefObject } from 'react';

/**
 * Универсальный хук для фокусировки на элементе, если выполнено определённое условие.
 * Поддерживает установку курсора в конец текста.
 *
 * @param ref - Ссылка на элемент, который нужно фокусировать.
 * @param condition - Условие для выполнения фокуса.
 * @param options - Дополнительные настройки.
 *   - setCursorToEnd: Установить курсор в конец текста (если элемент - input/textarea).
 *   - onFocus: Callback, выполняемый при установке фокуса.
 */
export const useFocusOnCondition = (
	ref: RefObject<HTMLElement>,
	condition: boolean,
	options?: {
		setCursorToEnd?: boolean;
		onFocus?: (element: HTMLElement) => void;
	}
) => {
	useEffect(() => {
		if (condition && ref.current) {
			ref.current.focus();

			if (options?.setCursorToEnd && ref.current instanceof HTMLInputElement) {
				const length = ref.current.value.length;
				ref.current.setSelectionRange(length, length);
			}

			if (options?.onFocus) {
				options.onFocus(ref.current);
			}
		}
	}, [condition, ref, options]);
};
